import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {GET_TRANSACTION_DETAILS_LISTING_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_TRANSACTION_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

interface Input {
  candidateUuid: string;
  onSuccess?: (data: TransactionRecordDetailsResponseModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export interface TransactionRecordDetailsListingObjectModel {
  examYear: string;
  transactionDesc: string;
  transactionDate: string;
  paymentDate: string;
  paymentMode: string;
  paymentReferenceNo: string;
  transactionAmt: string;
}

export interface TransactionRecordDetailsResponseModel {
  cddtPayableFeeModels: TransactionRecordDetailsListingObjectModel[];
  paymentTransactionModels: TransactionRecordDetailsListingObjectModel[];
  feePayable: string;
  paymentTransaction: string;
  outstandingAmount: string;
  examLevel: string;
  name: string;
  userIdType: string;
  nric: string;
  lastUpdatedOn: string;
}

export const useGetTransactionListing = ({candidateUuid, onSuccess, onError}: Input) => {
  const getTransactionListing = async () => {
    const res = await axiosClient.get<TransactionRecordDetailsResponseModel>(
        GET_TRANSACTION_DETAILS_LISTING_URL(candidateUuid ?? '')
    );
    return res.data;
  };

  return useCustomQuery(GET_TRANSACTION_QUERY_KEY, getTransactionListing, {
    onSuccess,
    onError,
  });
};
